<div class="slider-container"
     (mouseup)="endDrag()"
     (mouseleave)="endDrag()"
     (mousemove)="onDrag($event)"
     (touchend)="endDrag()"
     (touchmove)="onTouchMove($event)">

  <div class="slider-track">
    <div class="slider-thumb"
         [ngStyle]="{ left: thumbPosition + 'px' }"
         (mousedown)="startDrag($event)"
         (touchstart)="startTouch($event)">
      ▶
    </div>
    <div class="slider-text" *ngIf="!slideConfirmed">
      {{ slideText }}
    </div>
  </div>
</div>
